(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      const tag = this.querySelector('[data-bb-products]');
      try {
        this.products = JSON.parse(tag.textContent);
      } catch (e) {
        this.products = [];
      }
      if (!this.products.length) return;

      this.bundlePrice = Number(this.dataset.bundlePrice || 0);
      this.status = this.querySelector('[data-bb-status]');
      this.addButton = this.querySelector('[data-bb-add]');
      this.pairs = [...this.querySelectorAll('[data-pair]')];

      this.pairs.forEach((pair, index) => {
        this.fillProducts(pair, index);
        pair.addEventListener('change', (event) => {
          // Colour drives which sizes exist, so a product change rebuilds both.
          if (event.target.matches('[data-bb-product]')) this.fillColours(pair);
          if (event.target.matches('[data-bb-product],[data-bb-colour]')) this.fillSizes(pair);
          this.paint();
        });
        this.fillColours(pair);
        this.fillSizes(pair);
      });

      this.addButton.addEventListener('click', () => this.add());
      this.paint();
    }

    product(pair) {
      const handle = pair.querySelector('[data-bb-product]').value;
      return this.products.find((p) => p.handle === handle);
    }

    /* Only combinations that exist and are in stock are ever offered. */
    available(pair) {
      const p = this.product(pair);
      return p ? p.variants.filter((v) => v.available) : [];
    }

    fill(select, values, keep) {
      const previous = keep ? select.value : null;
      select.replaceChildren(
        ...values.map((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          return option;
        })
      );
      if (previous && values.includes(previous)) select.value = previous;
    }

    fillProducts(pair, index) {
      const select = pair.querySelector('[data-bb-product]');
      select.replaceChildren(
        ...this.products.map((p) => {
          const option = document.createElement('option');
          option.value = p.handle;
          option.textContent = p.title;
          return option;
        })
      );
      // Default the two pairs to different products, which is what the offer is for.
      if (this.products[index]) select.value = this.products[index].handle;
    }

    fillColours(pair) {
      const colours = [...new Set(this.available(pair).map((v) => v.colour))];
      this.fill(pair.querySelector('[data-bb-colour]'), colours, true);
    }

    fillSizes(pair) {
      const colour = pair.querySelector('[data-bb-colour]').value;
      const sizes = this.available(pair)
        .filter((v) => v.colour === colour)
        .map((v) => v.size)
        .sort((a, b) => Number(a) - Number(b));
      this.fill(pair.querySelector('[data-bb-size]'), sizes, true);
    }

    variant(pair) {
      const colour = pair.querySelector('[data-bb-colour]').value;
      const size = pair.querySelector('[data-bb-size]').value;
      return this.available(pair).find((v) => v.colour === colour && v.size === size);
    }

    paint() {
      this.pairs.forEach((pair) => {
        const p = this.product(pair);
        const image = pair.querySelector('[data-bb-image]');
        if (p && p.image) {
          image.src = p.image;
          image.alt = p.title;
        }
      });

      const chosen = this.pairs.map((pair) => this.variant(pair));
      const ready = chosen.every(Boolean);
      this.addButton.disabled = !ready;
    }

    async add() {
      const items = this.pairs
        .map((pair) => this.variant(pair))
        .filter(Boolean)
        .map((v) => ({ id: v.id, quantity: 1 }));
      if (items.length < this.pairs.length) return;

      this.addButton.disabled = true;
      this.status.removeAttribute('data-error');
      this.status.textContent = this.dataset.addingLabel || '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || body.message || 'add failed');
        }
        window.location.href = '/cart';
      } catch (error) {
        // Never strand someone on a page whose button silently did nothing.
        this.status.setAttribute('data-error', '');
        this.status.textContent = error.message;
        this.addButton.disabled = false;
      }
    }
  }

  if (!customElements.get('bundle-builder')) customElements.define('bundle-builder', BundleBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-bundle-toggle]').forEach(function (btn) {
        if (btn.dataset.bundleReady) return;
        btn.dataset.bundleReady = '1';

        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var open = false;

        function label() {
          var t = btn.querySelector('.bundle__reveal-text');
          var next = open ? btn.dataset.labelOpen : btn.dataset.labelClosed;
          if (t && next) t.textContent = next;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        // Closed by script, not by markup: without JS the offer stays visible.
        panel.hidden = true;
        label();

        /* The card photographs live inside a panel that is display:none until the
           reveal is pressed, and they are loading="lazy". A lazy image inside a
           display:none ancestor does not begin downloading at all, so the fetch
           only STARTS on the press and the cards come up empty for as long as the
           download takes. That is what Erez saw in the session recordings.

           Fix without making everyone pay for images they may never see: warm them
           into the HTTP cache shortly before they are needed, using a detached
           Image so the layout is untouched. By press time the real <img> is a
           cache hit. Warming happens when the section nears the viewport, and
           again the moment a pointer or focus lands on the trigger, whichever
           comes first. */
        var warmed = false;
        function fetchCards() {
          panel.querySelectorAll('img').forEach(function (img) {
            var pre = new Image();
            var sizes = img.getAttribute('sizes');
            var srcset = img.getAttribute('srcset');
            var src = img.getAttribute('src');
            if (sizes) pre.sizes = sizes;
            if (srcset) pre.srcset = srcset;   // set before src so the right candidate is chosen
            if (src) pre.src = src;
          });
        }
        /* The visibility path waits for the page to finish loading first: these are about
           380 KB the visitor may never open, and they were landing in the first second of
           every visit (measured 2026-10-04). A pointer or finger on the trigger still warms
           at once, because then the press is seconds away. */
        function warmCards(now) {
          if (warmed) return;
          warmed = true;
          if (now === true || document.readyState === 'complete') { setTimeout(fetchCards, now === true ? 0 : 1200); return; }
          window.addEventListener('load', function () { setTimeout(fetchCards, 1200); }, { once: true });
        }

        ['pointerenter', 'focus', 'touchstart'].forEach(function (evt) {
          btn.addEventListener(evt, function () { warmCards(true); }, { once: true, passive: true });
        });

        if ('IntersectionObserver' in window) {
          var warmIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              warmCards();
              warmIO.disconnect();
            });
          }, { rootMargin: '400px 0px' });
          warmIO.observe(btn);
        } else {
          warmCards();
        }

        function setOpen(next, animate) {
          open = next;
          if (!animate) {
            panel.hidden = !open;
            label();
            return;
          }
          btn.click();
        }

        // The quiz sends a couple to #offer. Landing on a collapsed panel would
        // strand the best answer in the survey, so the anchor opens it.
        function openIfTargeted() {
          if (window.location.hash !== '#offer' || open) return;
          setOpen(true, false);
        }
        openIfTargeted();
        window.addEventListener('hashchange', openIfTargeted);
        document.addEventListener('click', function (e) {
          var a = e.target.closest && e.target.closest('a[href$="#offer"]');
          if (a) setTimeout(openIfTargeted, 0);
        });

        btn.addEventListener('click', function () {
          open = !open;

          if (reduce) {
            panel.hidden = !open;
            label();
            return;
          }

          if (open) {
            panel.hidden = false;
            var h = panel.scrollHeight;
            panel.setAttribute('data-animating', '');
            panel.style.height = '0px';
            panel.style.transition = 'height 0.42s cubic-bezier(0.22, 0.61, 0.36, 1)';
            requestAnimationFrame(function () { panel.style.height = h + 'px'; });
            panel.addEventListener('transitionend', function done(e) {
              if (e.propertyName !== 'height') return;
              panel.removeEventListener('transitionend', done);
              panel.style.height = '';
              panel.style.transition = '';
              panel.removeAttribute('data-animating');
            });
          } else {
            var from = panel.scrollHeight;
            panel.setAttribute('data-animating', '');
            panel.style.height = from + 'px';
            panel.style.transition = 'height 0.34s cubic-bezier(0.22, 0.61, 0.36, 1)';
            requestAnimationFrame(function () { panel.style.height = '0px'; });
            panel.addEventListener('transitionend', function done(e) {
              if (e.propertyName !== 'height') return;
              panel.removeEventListener('transitionend', done);
              panel.hidden = true;
              panel.style.height = '';
              panel.style.transition = '';
              panel.removeAttribute('data-animating');
            });
          }

          label();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-quiz"] && !Shopify.designMode) return;
  try {
    
  class FitQuiz extends HTMLElement {
    connectedCallback() {
      this.total = Number(this.dataset.total || 0);
      this.key = this.dataset.storageKey;
      this.answers = this.load();

      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.live = this.querySelector('[data-live]');

      this.addEventListener('click', this.onClick);
      /* Dormant since 2026-09-17: Erez removed the email capture, so .fit-quiz__form no
         longer renders and this never binds. Left in place deliberately, because it rebinds
         by itself if show_email is turned back on. A zero here means switched off, not
         broken; see [[Measurement Plan]]. */
      this.querySelector('.fit-quiz__form')?.addEventListener('submit', () =>
        this.emit('lead_submitted')
      );

      // Coming back from a successful submit: go straight to the result.
      if (this.dataset.posted === 'true') this.show('result');
      else this.show('intro');

      this.paint();
    }

    load() {
      try {
        return JSON.parse(localStorage.getItem(this.key)) || {};
      } catch (e) {
        return {};
      }
    }

    save() {
      try {
        localStorage.setItem(this.key, JSON.stringify(this.answers));
      } catch (e) {
        /* private mode, blocked storage - the quiz still works, just not resumable */
      }
    }

    /* Measurement only. The quiz works identically with nothing listening.
       Answers carry the option value, never anything a visitor typed. */
    emit(name, detail) {
      this.dispatchEvent(
        new CustomEvent('fit-quiz:' + name, { bubbles: true, detail: detail || {} })
      );
    }

    onClick = (event) => {
      const option = event.target.closest('[data-option]');
      if (option) return this.choose(option);

      if (event.target.closest('[data-start]')) {
        this.emit('started');
        return this.go(1);
      }
      const goto = event.target.closest('[data-goto]');
      if (goto) {
        this.emit('answer_edit', { q: Number(goto.dataset.goto) });
        return this.go(Number(goto.dataset.goto));
      }

      if (event.target.closest('[data-back]')) return this.back();
      if (event.target.closest('[data-restart]')) return this.restart();
    };

    choose(button) {
      const panel = button.closest('[data-panel="question"]');
      const index = Number(panel.dataset.index);

      panel.querySelectorAll('[data-option]').forEach((el) => {
        el.classList.toggle('is-selected', el === button);
      });

      /* option is the choice's position, 1-based. It is what the product page carries into the
         order as a hidden line-item property so the guide can start from these answers: a
         number, never the label, so no Hebrew health-adjacent text travels with the order. */
      this.answers[index] = {
        question: button.dataset.question,
        value: button.dataset.value,
        option: Array.prototype.indexOf.call(panel.querySelectorAll('[data-option]'), button) + 1,
        destination: button.dataset.destination || '',
      };
      this.save();
      this.emit('answered', { q: index, value: button.dataset.value });

      // A short beat so the choice is visibly registered before moving on.
      const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
      setTimeout(() => {
        if (index >= this.total) this.finish();
        else this.go(index + 1);
      }, delay);
    }

    go(index) {
      this.current = index;
      this.show('question', index);
      this.announce(index + ' / ' + this.total);
    }

    back() {
      if (this.current > 1) this.go(this.current - 1);
      else this.show('intro');
    }

    finish() {
      this.show('result');
      this.paintAnswers();
      this.applyDestination();
      this.announce('Done');

      /* Measurement. This MUST run after applyDestination() above, which resolves the href
         from the answers. Reordered, it would silently report the Liquid default instead of
         the route, and a default looks like a value rather than a gap.
         A bare '#' IS that default and means no destination, so it is normalised away.
         '#offer' is a real route, the two-pair panel: it opens in place and never navigates,
         so it produces no page view and this event is the only thing that can see it. */
      const routed = this.querySelector('.fit-quiz__cta')?.getAttribute('href') || '';
      this.emit('completed', {
        answers: Object.values(this.answers).map((a) => a.value),
        destination: routed === '#' ? '' : routed,
      });
    }

    restart() {
      this.emit('restarted');
      this.answers = {};
      this.save();
      this.querySelectorAll('.is-selected').forEach((el) => el.classList.remove('is-selected'));
      this.show('intro');
    }

    show(name, index) {
      this.panels.forEach((panel) => {
        const match =
          panel.dataset.panel === name &&
          (index === undefined || Number(panel.dataset.index) === index);
        panel.hidden = !match;
        if (match) {
          // Reflow between remove and add so the animation restarts every time.
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
    }

    // Restore any previously chosen options so Back and a reload both look right.
    paint() {
      Object.entries(this.answers).forEach(([index, answer]) => {
        const panel = this.querySelector('[data-panel="question"][data-index="' + index + '"]');
        if (!panel) return;
        panel.querySelectorAll('[data-option]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === answer.value);
        });
      });
      this.applyDestination();
    }

    /* The last answered question that carries a destination decides where the result
       button goes, so the routing question can sit anywhere in the order. A button with
       nowhere to go is hidden rather than left pointing at '#'. */
    applyDestination() {
      const cta = this.querySelector('.fit-quiz__cta');
      if (!cta) return;

      let destination = '';
      for (let i = 1; i <= this.total; i++) {
        const answer = this.answers[i];
        if (answer && answer.destination) destination = answer.destination;
      }
      if (destination) cta.setAttribute('href', destination);

      const href = cta.getAttribute('href');
      cta.style.display = !href || href === '#' ? 'none' : '';
    }

    /* Each answer on the result screen is a button back to its own question. A recording on
       2026-09-19 showed someone read their answers, click one to change it, get nothing,
       and restart the whole quiz rather than use Back. Reading a summary and reaching for
       the line you want to change is the obvious gesture; it should work. */
    paintAnswers() {
      const list = this.querySelector('[data-answers]');
      const body = this.querySelector('[data-body]');
      const lines = [];
      const rows = [];

      for (let i = 1; i <= this.total; i++) {
        const answer = this.answers[i];
        if (!answer) continue;
        lines.push(answer.question + ' - ' + answer.value);
        rows.push({ index: i, question: answer.question, value: answer.value });
      }

      if (list) {
        list.replaceChildren(
          ...rows.map((row) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'fit-quiz__answer';
            button.dataset.goto = row.index;
            button.setAttribute(
              'aria-label',
              (this.dataset.editLabel || 'Change') + ': ' + row.question + ' - ' + row.value
            );
            const q = document.createElement('span');
            q.className = 'fit-quiz__answer-q';
            q.textContent = row.question;
            const v = document.createElement('span');
            v.className = 'fit-quiz__answer-v';
            v.textContent = row.value;
            button.append(q, v);
            return button;
          })
        );
      }

      if (body) body.value = lines.join('\n');
    }

    announce(text) {
      if (this.live) this.live.textContent = text;
    }
  }

  if (!customElements.get('fit-quiz')) customElements.define('fit-quiz', FitQuiz);

  /* The start button announces itself once when it reaches the screen, the same
     way the listen button does in the science section. Removed on first press,
     and never shown again for someone who has already begun. */
  /* Deferred, because the quiz is a custom element: running at script-parse time
     found no button at all and the hint silently never appeared. Measured that
     way round before this was fixed -- the class was simply never added. */
  (function () {
    function initHint() {
      if (!('IntersectionObserver' in window)) return;
      document.querySelectorAll('.fit-quiz__start').forEach(function (start) {
        if (start.dataset.hintReady) return;
        start.dataset.hintReady = '1';
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            start.classList.add('is-hinting');
            io.disconnect();
          });
        }, { threshold: 0.6 });
        io.observe(start);
        start.addEventListener('click', function () {
          start.classList.remove('is-hinting');
        }, { once: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHint);
    } else {
      initHint();
    }
    document.addEventListener('shopify:section:load', initHint);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-promise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (!phone) return;
    document.querySelectorAll('.guide__fold[data-fold-mobile]').forEach(function (fold) {
      fold.removeAttribute('open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var tag = document.querySelector('[data-pl-videos]');
      if (!tag) return;

      // Hover is a desktop affordance. On touch the still stays, deliberately:
      // autoplaying two clips in a grid is tens of megabytes for someone who may
      // be on cellular, and most of this store's traffic will be phones.
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      // On the homepage list the photo must react exactly like the text under it. The theme's
      // "second image on hover" is an on:pointerenter/on:pointerleave pair on the gallery (photo
      // area only), dispatched by a document-level listener that reads the attribute at event
      // time. Removing the pair on these cards leaves the whole-card hover (lift, clip, quick add).
      document.querySelectorAll('#products .card-gallery').forEach(function (g) {
        g.removeAttribute('on:pointerenter');
        g.removeAttribute('on:pointerleave');
      });

      var map;
      try { map = JSON.parse(tag.textContent); } catch (e) { return; }

      document.querySelectorAll('.section-resource-list product-card').forEach(function (card) {
        if (card.dataset.plReady) return;
        var link = card.querySelector('a.product-card__link') || card.querySelector('a[href]');
        if (!link) return;
        var path = link.getAttribute('href').split('?')[0];
        var entry = map[path];
        if (!entry) return;
        card.dataset.plReady = '1';

        var media = card.querySelector('.product-media-container') || card.querySelector('.product-media');
        if (!media) return;
        var video = null;

        function enter() {
          if (!video) {
            video = document.createElement('video');
            video.className = 'pl-hover-video';
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.preload = 'none';
            video.setAttribute('aria-hidden', 'true');
            video.setAttribute('tabindex', '-1');
            video.src = entry.src;
            media.appendChild(video);
          }
          media.setAttribute('data-pl-hovering', '');
          var p = video.play();
          if (p && p.then) p.then(function () { video.setAttribute('data-playing', ''); }).catch(function () {});
          else video.setAttribute('data-playing', '');
        }

        function leave() {
          media.removeAttribute('data-pl-hovering');
          if (!video) return;
          video.removeAttribute('data-playing');
          video.pause();
        }

        // pointerenter can miss when a child component handles the pointer itself,
        // so listen on the media area too and use pointerover, which bubbles.
        card.addEventListener('pointerenter', enter);
        card.addEventListener('pointerover', enter);
        card.addEventListener('pointerleave', leave);
        media.addEventListener('pointerover', enter);
        // keyboard users get it too, since the card link is focusable
        link.addEventListener('focus', enter);
        link.addEventListener('blur', leave);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (phone) {
      document.querySelectorAll('.sci__fold[data-fold-mobile]').forEach(function (fold) {
        fold.removeAttribute('open');
      });
    }
    var charts = document.querySelectorAll('.sci__chart');
    if (!charts.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) return;
    charts.forEach(function (chart) { chart.classList.add('sci__chart--js'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.3 });
    charts.forEach(function (chart) { io.observe(chart); });
  })();

  /* The listen button. Plain DOM, no dependencies, and it degrades to a native
     <audio> element if any of this throws. */
  (function () {
    var wrap = document.querySelector('[data-sci-audio-wrap]');
    if (!wrap) return;
    var audio = wrap.querySelector('[data-sci-audio]');
    var btn = wrap.querySelector('[data-sci-play]');
    var bar = wrap.querySelector('[data-sci-bar]');
    var fill = wrap.querySelector('[data-sci-fill]');
    var timeEl = wrap.querySelector('[data-sci-time]');
    var status = wrap.querySelector('[data-sci-status]');
    if (!audio || !btn) return;

    var idleNote = status ? status.textContent : '';
    var L = {
      playing: wrap.getAttribute('data-l-playing') || 'מתנגן…',
      paused: wrap.getAttribute('data-l-paused') || 'מושהה — לחצו להמשך',
      done: wrap.getAttribute('data-l-done') || 'ההסבר הסתיים. אפשר לשמוע שוב',
      error: wrap.getAttribute('data-l-error') || 'לא הצלחנו להשמיע. נסו שוב'
    };

    function clock(t) {
      if (!isFinite(t) || t < 0) t = 0;
      var m = Math.floor(t / 60), sec = Math.floor(t % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    function say(t) { if (status) status.textContent = t; }

    btn.addEventListener('click', function () {
      if (audio.paused) {
        // One narration at a time: silence any video already playing on the page.
        document.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
        var p = audio.play();
        if (p && p.catch) p.catch(function () { say(L.error); });
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      wrap.classList.add('is-playing');
      if (bar) bar.hidden = false;
      say(L.playing);
    });
    audio.addEventListener('pause', function () {
      wrap.classList.remove('is-playing');
      if (!audio.ended) say(L.paused);
    });
    audio.addEventListener('ended', function () {
      wrap.classList.remove('is-playing');
      say(L.done);
      if (fill) fill.style.inlineSize = '100%';
    });
    audio.addEventListener('error', function () { say(L.error); });
    audio.addEventListener('timeupdate', function () {
      if (!audio.duration || !isFinite(audio.duration)) return;
      if (fill) fill.style.inlineSize = (audio.currentTime / audio.duration * 100) + '%';
      var r = audio.playbackRate || 1;
      if (timeEl) timeEl.textContent = clock(audio.currentTime / r) + ' / ' + clock(audio.duration / r);
    });
    audio.addEventListener('loadedmetadata', function () {
      if (timeEl) timeEl.textContent = clock(0) + ' / ' + clock(audio.duration / (audio.playbackRate || 1));
    });

    // Speed. preservesPitch defaults to true in current browsers, but it is set
    // explicitly (and under the WebKit prefix) because a narration that chipmunks
    // at 2x is worse than having no speed control at all.
    var rateBtns = wrap.querySelectorAll('[data-sci-rate]');
    function setRate(r) {
      try {
        audio.preservesPitch = true;
        audio.webkitPreservesPitch = true;
        audio.mozPreservesPitch = true;
      } catch (e) {}
      audio.playbackRate = r;
      rateBtns.forEach(function (b) {
        var on = parseFloat(b.getAttribute('data-sci-rate')) === r;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    rateBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setRate(parseFloat(b.getAttribute('data-sci-rate')));
      });
    });
    // The clock must report real remaining time, not source seconds, or a
    // listener at 2x is told a minute is left when twenty seconds are.
    audio.addEventListener('ratechange', function () {
      if (timeEl && audio.duration && isFinite(audio.duration)) {
        timeEl.textContent = clock(audio.currentTime / audio.playbackRate) +
          ' / ' + clock(audio.duration / audio.playbackRate);
      }
    });

    /* Draw the eye once, when it arrives on screen. */
    if ('IntersectionObserver' in window) {
      var hintIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          btn.classList.add('is-hinting');
          hintIO.disconnect();
        });
      }, { threshold: 0.6 });
      hintIO.observe(btn);
    }
    btn.addEventListener('click', function () {
      btn.classList.remove('is-hinting');
    }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      document.querySelectorAll('[data-sv-stage]').forEach(function (stage) {
        if (stage.dataset.svReady) return;
        stage.dataset.svReady = '1';

        var teaser = stage.querySelector('[data-sv-teaser]');
        var main = stage.querySelector('[data-sv-main]');
        var btn = stage.querySelector('[data-sv-play]');
        if (!main || !btn) return;

        // A looping clip is decoration. Honour a stated preference for less motion.
        if (teaser && reduce) { teaser.removeAttribute('autoplay'); teaser.pause(); }

        function fullscreen(el) {
          var fn = el.requestFullscreen || el.webkitRequestFullscreen ||
                   el.webkitEnterFullscreen || el.msRequestFullscreen;
          if (!fn) return null;
          try { return fn.call(el); } catch (e) { return null; }
        }

        /* Measurement of what the phone actually did after the press, published through
           the theme's own tracker when it is present. Each is a Clarity tag, so a session
           recording shows it next to the tap. */
        function emit(name, data) {
          try { if (window.Balanced && window.Balanced.track) window.Balanced.track(name, data || {}); } catch (e) {}
        }
        function srcTail() { return (main.currentSrc || '').split('/').pop().slice(0, 40); }

        var fallback = stage.querySelector('[data-sv-fallback]');
        var started = false;
        function showFallback(reason) {
          if (!fallback || !fallback.hidden || started) return;
          fallback.hidden = false;
          emit('video_fallback_shown', { reason: reason });
        }
        if (fallback) fallback.addEventListener('click', function () { emit('video_fallback_clicked', {}); });

        main.addEventListener('playing', function () {
          if (started) return;
          started = true;
          emit('video_playing', { src: srcTail() });
          if (fallback) fallback.hidden = true;
        });
        /* iPhone gets Shopify's adaptive stream (480p, 720p, 1080p) instead of the one 31.6 MB
           file (2026-10-07). The CP-02 visitor tapped the film three times, 31 s in, inside
           Facebook on mobile data, which is what a stall looks like. iOS plays HLS itself and
           steps down when the connection is slow; the MP4 cannot. Only on the iPhone path:
           Chrome takes the 480p rung and stays there (see the comment on the mobile sources),
           so Android and desktop keep the MP4. If the stream fails, the MP4 is the retry. */
        var usedHls = false;
        function hlsFor(v) {
          var s = v.querySelector('source');
          var m = s && (s.getAttribute('src') || '').match(/^(https:\/\/cdn\.shopify\.com\/videos\/c\/vp\/([0-9a-f]+)\/)\2\.[^\/]+\.mp4$/);
          if (!m || !v.canPlayType('application/vnd.apple.mpegurl')) return '';
          return m[1] + m[2] + '.m3u8';
        }

        main.addEventListener('error', function () {
          emit('video_error', { code: main.error ? main.error.code : 0, src: srcTail(), hls: usedHls });
          if (usedHls && !started) {
            usedHls = false;
            main.removeAttribute('src');
            try { main.load(); } catch (e) {}
            var again = main.play();
            if (again && again.catch) again.catch(function () { showFallback('error'); });
            return;
          }
          showFallback('error');
        });

        btn.addEventListener('click', function () {
          main.hidden = false;
          main.controls = true;
          main.muted = false;
          btn.hidden = true;
          if (teaser) { teaser.pause(); teaser.hidden = true; }
          var cover = stage.querySelector('[data-sv-cover]');
          if (cover) cover.hidden = true;

          try { main.currentTime = 0; } catch (e) {}

          var iosPlayer = typeof main.webkitEnterFullscreen === 'function' && !main.requestFullscreen;

          /* iPhone: the film plays inline, in a frame that on a phone is already the full
             screen, with the native controls offering the phone's player in one tap. Pushing
             it into that player from script was tried twice on 2026-09-18: the player opened
             and drew nothing. preload="none" means no source has been chosen yet, so load()
             first, inside the tap, then play(). */
          if (iosPlayer) {
            var hls = hlsFor(main);
            if (hls) { main.src = hls; usedHls = true; }
            try { main.load(); } catch (e) {}
          }

          var played = main.play();
          if (played && played.catch) {
            played.catch(function (err) {
              emit('video_play_rejected', { name: err && err.name ? String(err.name) : 'unknown' });
              showFallback('rejected');
            });
          }

          /* If nothing is playing three seconds after the press, offer the file itself.
             Three, not five: an older visitor who sees nothing happen has already given up. */
          setTimeout(function () {
            if (started) return;
            emit('video_not_started', { ready: main.readyState, net: main.networkState, paused: main.paused, err: main.error ? main.error.code : 0 });
            showFallback('timeout');
          }, 3000);

          if (iosPlayer) return;

          var after = function () {
            var r = fullscreen(main) || fullscreen(stage);
            if (r && r.catch) r.catch(function () {});
          };
          if (played && played.then) { played.then(after).catch(after); } else { after(); }
        });

        /* The film's last frames tell the viewer to scroll down to the quiz. On a
           phone that instruction is unfollowable: they are inside the native
           player and there is nothing to scroll. So when the film ENDS we leave
           the player for them and carry them to the quiz.

           Only on a real ending. Someone who closes the player early is choosing
           to stop, and hijacking their scroll position would be the site arguing
           with them. iOS fires webkitendfullscreen on every close, so it is gated
           on the film actually having finished. */
        var finished = false;

        function goToQuiz() {
          var root = stage.closest('.story-video');
          var sel = (root && root.getAttribute('data-sv-end-target')) || '#quiz';
          var target = document.querySelector(sel);
          if (!target) return;
          try {
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          } catch (e) {
            target.scrollIntoView();
          }
          emit('video_ended_to_quiz', {});
        }

        function leaveFullscreen() {
          try {
            if (document.fullscreenElement && document.exitFullscreen) {
              return document.exitFullscreen(), true;
            }
            if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
              return document.webkitExitFullscreen(), true;
            }
            if (typeof main.webkitExitFullscreen === 'function') {
              return main.webkitExitFullscreen(), true;
            }
          } catch (e) {}
          return false;
        }

        var rootEl = stage.closest('.story-video');
        var endScroll = !rootEl || rootEl.getAttribute('data-sv-end-scroll') !== 'false';

        var endCard = stage.querySelector('[data-sv-end]');
        var again = stage.querySelector('[data-sv-again]');
        var skip = rootEl && rootEl.querySelector('[data-sv-skip]');
        function showEnd() {
          if (endCard) endCard.hidden = false;
          if (skip) skip.hidden = true;
        }
        main.addEventListener('playing', function () { if (skip) skip.hidden = false; });
        if (skip && !skip.dataset.svBound) {
          skip.dataset.svBound = '1';
          skip.addEventListener('click', function () {
            /* Leaving the film for the shoes: stop the sound, then let the anchor scroll. */
            rootEl.querySelectorAll('[data-sv-main]').forEach(function (v) {
              if (!v.paused) {
                emit('video_skip_to_products', { at: Math.round(v.currentTime) });
                try { v.pause(); } catch (e) {}
              }
            });
            leaveFullscreen();
          });
        }
        if (again) {
          again.addEventListener('click', function () {
            if (endCard) endCard.hidden = true;
            try { main.currentTime = 0; } catch (e) {}
            var r = main.play(); if (r && r.catch) r.catch(function () {});
          });
        }
        main.addEventListener('playing', function () { if (endCard) endCard.hidden = true; });

        main.addEventListener('ended', function () {
          finished = true;
          showEnd();
          if (!endScroll) return;
          var left = leaveFullscreen();
          /* Scrolling while the browser is still collapsing the fullscreen view
             lands against a layout that is about to change, so the target ends up
             in the wrong place. Wait for the exit to settle. */
          setTimeout(goToQuiz, left ? 500 : 80);
        });

        /* iOS: the native player closing is the only signal we get back. */
        main.addEventListener('webkitendfullscreen', function () {
          if (!endScroll) return;
          var nearEnd = main.duration && (main.currentTime >= main.duration - 1.5);
          if (finished || nearEnd) { showEnd(); setTimeout(goToQuiz, 150); }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    /* A link anywhere on the page to #video (the phone hero's "למה זה טוב לי?") brings the
       visitor to the film and presses play for them, inside their own tap so sound is
       allowed. Only the stage that is actually displayed gets pressed; the other is
       display:none and has no offsetParent. Without script the link still scrolls here. */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href$="#video"]') : null;
      if (!a) return;
      var root = document.getElementById('video');
      if (!root) return;
      e.preventDefault();
      var btn = null;
      root.querySelectorAll('[data-sv-play]').forEach(function (b) {
        if (!btn && !b.hidden && b.offsetParent !== null) btn = b;
      });
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (btn) btn.click();
    });

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
